import styled from 'styled-components'

const ChapterStyled = styled.div`
  padding: var(--chapter-py) 0;
  background-color: transparent;
  border-bottom: var(--b-default);
`

export default ChapterStyled
